import React from 'react'
import { ChevronDown } from 'lucide-react'
import { languageConfigs } from '../lib/problems'

interface LanguageSelectorProps {
  selectedLanguage: string
  onLanguageChange: (language: string) => void
  supportedLanguages?: string[]
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  selectedLanguage,
  onLanguageChange,
  supportedLanguages = ['python', 'javascript', 'java', 'cpp']
}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const availableLanguages = supportedLanguages.filter(lang => languageConfigs[lang as keyof typeof languageConfigs])

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <span className="text-sm font-medium text-gray-700">
          {languageConfigs[selectedLanguage as keyof typeof languageConfigs]?.name || 'Select Language'}
        </span>
        <ChevronDown className="h-4 w-4 text-gray-500" />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
          {availableLanguages.map((lang) => {
            const config = languageConfigs[lang as keyof typeof languageConfigs]
            return (
              <button
                key={lang}
                onClick={() => {
                  onLanguageChange(lang)
                  setIsOpen(false)
                }}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
                  selectedLanguage === lang ? 'bg-primary-50 text-primary-700' : 'text-gray-700'
                }`}
              >
                {config?.name}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default LanguageSelector 